import graphqlClient from '~/graphql/graphqlClient';
import {
  MutationSpawnCavernsMobArgs,
  SpawnCavernsMobResult,
} from 'dt-common/generated/graphql-types';

const mutation = `
mutation SpawnCavernsMob(
  $playerId: String!
  $game_submode: String!
  $spawnX: Int!
  $spawnY: Int!
) {
  spawnCavernsMob(
    playerId: $playerId
    game_submode: $game_submode
    spawnX: $spawnX
    spawnY: $spawnY
  ) {
    mob
  }
}`;

export default async function mutationSpawnCavernsMob(args: MutationSpawnCavernsMobArgs) {
  return await graphqlClient.request<SpawnCavernsMobResult>('spawnCavernsMob', mutation, args);
}
